import getLocale from '../getLocale';
/**
 * @deprecated Helper functions parseLocale or parseLocaleFromPath should be used instead
 * @see parseLocale
 * @see parseLocaleFromPath
 *
 * Gets user's current market
 *
 * @param {Format} [format=upperCase] - Format
 * @return {string} - The user's current market
 *
 * @example
 * // returns GB
 * getMarket()
 */
const getMarket = (format = 'upperCase') => getLocale(format).split(/[-_]/).pop();
export default getMarket;
//# sourceMappingURL=getMarket.js.map